export default "__VITE_ASSET__ISk11dGK__"